import { render } from "./SupermercadosAtivos.vue?vue&type=template&id=4d0bd9f4"
import script from "./SupermercadosAtivos.vue?vue&type=script&lang=js"
export * from "./SupermercadosAtivos.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__